// extracted by mini-css-extract-plugin
module.exports = {"spacer":"CheckoutSavedCreditCard__spacer___BLqK3"};